import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import type { Dispatch, ReactElement, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

export function MoreDetailsDialog(
  props: Readonly<{ visible?: boolean; setShowMoreDetailsDialog: Dispatch<SetStateAction<boolean>> }>,
): ReactElement {
  const { t } = useTranslation('joinFunnel', { keyPrefix: 'JoinFunnel.MoreDetailsDialog' })
  return (
    <Dialog
      header={t('title')}
      visible={props.visible}
      className='w-2/3 xl:w-1/3'
      onHide={() => {
        props.setShowMoreDetailsDialog(false)
      }}
    >
      <div>
        <p>{t('text')}</p>
      </div>
      <div className='mt-4 text-center'>
        <Button rounded label={t('okBtnLabel')} onClick={() => props.setShowMoreDetailsDialog(false)}></Button>
      </div>
    </Dialog>
  )
}
